module.exports = __webpack_public_path__ + "img/hamburger.b49c48f7.svg";